import { getOriginFromUrl } from '@/utils';
import type { AuthClientParams } from '../../static/public/gid-sdk.es';

const origin = getOriginFromUrl(window.location);

type ButtonConfig = AuthClientParams['buttons'][number];

/**
 * Buttons configuration to instantiate the `AuthProvider`.
 */

export const buttonsConfig: ButtonConfig[] = [
  {
    container: '#button1',
    type: 'standard',
    color: 'primary',
  },
  {
    container: '#button2',
    type: 'compact',
    color: 'primary',
  },
  {
    container: '#button3',
    type: 'iconic',
    color: 'primary',
  },
  {
    container: '#button4',
    type: 'standard',
    color: 'secondary',
  },
  {
    container: '#button5',
    type: 'compact',
    color: 'secondary',
  },
  {
    container: '#button6',
    type: 'iconic',
    color: 'secondary',
  },
  {
    container: '#button7',
    type: 'standard',
    color: 'dark',
  },
  {
    container: '#button8',
    type: 'compact',
    color: 'dark',
  },
  {
    container: '#button9',
    type: 'iconic',
    color: 'dark',
  },
]

/**
 * The main configuration to instantiate the `AuthProvider`.
 */

export const config: any = {
  clientId: import.meta.env.GID_CLIENT_ID,
  redirectUri: origin,
  postLogoutUri: origin,
  authUrl: import.meta.env.GID_AUTH_URL,
  backendUrl: import.meta.env.GID_BACKEND_URL,
  scope: import.meta.env.GID_SCOPES,
  headers: {},
  webCurtainLoginType: 'redirect',
  keycloakEnabled: import.meta.env.GID_KEYCLOAK_ENABLED,
  keycloak_authUrl: import.meta.env.GID_KEYCLOAK_AUTH_URL,
  keycloak_clientId: import.meta.env.GID_KEYCLOAK_CLIENT_ID,
  keycloak_realmName: import.meta.env.GID_KEYCLOAK_REALM_NAME,
  keycloak_idpName: import.meta.env.GID_KEYCLOAK_IDP_NAME,
  debugConsole: import.meta.env.GID_DEBUG_CONSOLE,
  debugTrack: import.meta.env.GID_DEBUG_TRACK,
  device: 'WEB',
  sentryEnabled: true,
  preventAutoStorageCleanup: false,
  useStorage: 'session',
  requestTimeout: null,
  configCacheTtlDays: '7',
  loginTag: 'silent_login',
  type: '',
  trackers: 'goya,tracking_receiver',
};
